import React from 'react';

import styles from './styles.module.scss';

const months = [
  'sty',
  'lut',
  'mar',
  'kwi',
  'maj',
  'cze',
  'lip',
  'sie',
  'wrz',
  'paź',
  'lis',
  'gru',
];

const topBarTexts = {
  year: 'Wybierz rok',
  month: 'Wybierz miesiąc',
  date: 'Wybierz dzień',
};

export default function TopBar({ status, date }) {
  const heading = topBarTexts[status];

  return (
    <div className={styles.topBarContainer}>
      <div className={`${styles.dateContainer} ${styles[status]}`}>
        {status === 'date' && (
          <div className={styles.datePart}>{date.getDate()}</div>
        )}
        {status === 'date' && (
          <div className={styles.datePart}>{months[date.getMonth()]}</div>
        )}
        {status !== 'year' && (
          <div className={styles.datePart}>{date.getYear() + 1900}</div>
        )}
      </div>
      <div className={styles.heading}>{heading}</div>
    </div>
  );
}
